// extracted by mini-css-extract-plugin
export var blueBackground = "styles-module--blueBackground--akhiW";
export var body = "styles-module--body--pTp2k";
export var caption = "styles-module--caption--uOG0t";
export var flexContainer = "styles-module--flexContainer--ynqCf";
export var flexItems = "styles-module--flexItems--Xrm3b";
export var preFooter = "styles-module--preFooter--UpRpS";